import { Component, ViewChild, AfterViewInit, inject, ChangeDetectorRef } from '@angular/core';
import { MatDialog } from '@angular/material/dialog'
import { columnModel } from '../../../components/table/model/columnModel';
import { tableModel } from '../../../components/table/model/tableModel';
import { TableComponent } from '../../../components/table/table.component';
import { EmployDetailComponent } from '../employ-detail/employ-detail.component';
import { EmployeeListService } from '../../../services/employee-list.service';
import { Router } from '@angular/router';
import { MatExpansionPanel } from '@angular/material/expansion';
import { AlertaService } from '../../../services/alerta.service';
import { FilterEmployee } from '../../../models/filters/filter-employee';

@Component({
  selector: 'app-employ',
  standalone: false,
  templateUrl: './employ.component.html',
  styleUrl: './employ.component.css'
})

export class EmployComponent implements AfterViewInit{

@ViewChild(TableComponent) employTable:TableComponent | undefined;
@ViewChild('advancedPanel') advancedPanel!: MatExpansionPanel;

  tableModel: tableModel= {
    columnModel:[{columnName:'Numero Empleado',columnValue:'employeeNumber'},
      {columnName:'Nombre',columnValue:'nameEmployee'},
      {columnName:'Apellido Paterno',columnValue:'paternalSurnameE'},
      {columnName:'Apellido Materno',columnValue:'maternalSurnameE'},
      {columnName:'Posición',columnValue:'positionDesc'}],
    dataSource:[],
    //viewDetail:true,
    editButton:true
  };
  
  private employeeListService = inject(EmployeeListService);
  router = inject(Router);
  private cdr = inject(ChangeDetectorRef);
  private alerta = inject(AlertaService);

  constructor(public dialog: MatDialog){ }
  
  pageIndex: number = 1;
  pageSize: number = 5;
  loading: boolean = false;
  filterEmployee: FilterEmployee = new FilterEmployee;
  advancedSearch: boolean = false;

  ngAfterViewInit() {
    //Promise.resolve().then(() =>  this.employTable.initTable());
  }
  ngOnInit(): void {
    this.filterEmployee = new FilterEmployee();
    this.filterEmployee.ac = 1;
    this.searchBenefitsPaginator();
  }
  paginatorEvent(event: any){
    this.pageIndex = (event.pageIndex+1);
    this.pageSize = event.pageSize;
    this.searchBenefitsPaginator();
  }
  searchBenefitsPaginatorAS(){
    this.pageIndex = 1;
    this.advancedSearch = true;
    this.searchBenefitsPaginator();
  }
  searchBenefitsPaginator(){
    this.loading = true;

    this.employeeListService.findAllPageableEmployee(this.filterEmployee, this.pageIndex, this.pageSize).subscribe({
      next: (pageable) => {
        this.tableModel.pageSize = pageable.pageSize;
        this.tableModel.totalRecords = pageable.itemsCount;
        this.tableModel.dataSource = pageable.list;
        this.tableModel.pageNumber = pageable.pageNum;
        
        setTimeout(() => {
          this.employTable?.refresh(pageable.list, pageable.itemsCount);
        });
        this.loading = false;
        this.cdr.detectChanges();
      },
      error: (err) => {
        this.loading = false;
        if(err.status == 400){
          this.alerta.error("Se ha terminado el tiempo de session: ", {detail: err.message});
          this.router.navigate(['/login']);
        }else{
          this.alerta.error("Se ha precentado un error interno: ", {detail: err.message});
        }
      }
    });

    if(this.advancedPanel != null){
      if (this.advancedSearch) {
        this.advancedPanel.open();
      } else {
        this.advancedPanel.close();
      }
    }
  }

  editEvent(event: any){
    this.router.navigate(['/employee/detail', event.id]);
  }

}
